/* eslint-disable no-unused-vars */
import { axios } from '@/repositories'

const resource = '/v1/stay'

export default {
  async getOrderDetail(acptNo) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/order/${acptNo}`).then(
        (response) => {
          resolve(response.data)
        },  
        (error) => {
          reject(error?.error)
        }
      )
    })
  },

  async createOrder(reserveId, p, data) {
    const headers = {
      reserveId
    }
    const params = {
      p
    }
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/order`, data, {headers, params}).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.data)
        })
    })
  },

  async updateOrder(acptNo, reserveId, data) {
    const headers = {
      reserveId
    }
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/order-update?acptNo=${acptNo}`, data, {headers}).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        })
    })
  },

  async cancelOrder(acptNo, p, data) {
    if(!p) {
      return new Promise((resolve, reject) => {
        axios.put(`${resource}/order/order-cancel?acptNo=${acptNo}`, data).then(
          (res) => {
            resolve(res.data)
          },
          (error) => {
            reject(error?.error)
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        axios.put(`${resource}/order/order-cancel?acptNo=${acptNo}&p=${p}`, data).then(
          (res) => {
            resolve(res.data)
          },
          (error) => {
            reject(error?.error)
          })
      })
    }
  },

  async updateAvailableStock(menuNo, roomId, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/menu/${menuNo}/rooms/${roomId}/stay-stock`, data).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        })
    })
  },

  async deleteAvailableStock(menuNo, roomId, reserveId) {
    return new Promise((resolve, reject) => {
      axios.delete(`${resource}/menu/${menuNo}/rooms/${roomId}/stay-stock/${reserveId}`).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        })
    })
  },

  async createStayRequest(reserveId, p, data) {
    const headers = {
      reserveId
    }
    const params = {
      p
    }
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/stay-request`, data, {headers, params}).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.data)
        })
    })
  },
}

